<template>
    <div style="margin:auto">
      <LineChartGenerator 
        id='chart'
        :chart-options="chartOptions"
        :chart-data="chartData"
        :chart-id="chartId"
        :dataset-id-key="datasetIdKey"
        :plugins="plugins"
        :css-classes="cssClasses"
        :styles="styles"
        :width="width"
        :height="height"
      />
      <div id="modalpoint" class="row" style="position: absolute; z-index: 100; display: none;">
          <input type="number" min="0" step="0.01" id="modalNumberInput" name="numberInput" class="form-control w-75">
            <button type="button" class="buttonOriginal" @click="validateInput()" id="btnModal">
            <span class="glyphicon glyphicon-ok-sign" aria-hidden="true"></span>
          </button>
      </div>
    </div>
</template>
    
<script>
  import { Line as LineChartGenerator } from 'vue-chartjs/legacy';
  import 'chartjs-plugin-dragdata';
  import zoomPlugin from 'chartjs-plugin-zoom';
  import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    CategoryScale,
    PointElement
  } from 'chart.js';
  
  ChartJS.register(
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    CategoryScale,
    PointElement,
    zoomPlugin,
  );
  
  const colorPoint = ['#f8f879','#f87979','#79f879','#79f8f8'];
  
  export default {
    name: 'chartsCapexOpex',
    components: {
      LineChartGenerator
    },
    props: {
      datasetIdKey: 'label',
      width:  {
        type: Number,
        default: 1400
      },
      height: {
        type: Number,
        default: 520
      },
      cssClasses: '',
      styles: () => {},
      plugins: () => [],
      capex: {},
      opex: {},
      scale: {},
      mode:{},
    },
    data: function() {
      return {
        valeurPointMax:0,
        chartWidth: 0,
        dblclickbool: false,
        tempPoint: [],
        newPointValue:0,
        Mode:"",
        originalematrice:[],
        originalematriceCapex:[],
        originalematriceOpex:[],
        chartId: 'chart',
        chartData: {
          labels: [],
          datasets: [
            {
              label: "",
              backgroundColor: [], //'#f8f879',
              borderColor: [], //'#f8f879',
              pointStyle: 'rectRot',
              radius:[],
              data: [],
            },
            {
              label: "",
              backgroundColor: [], //'#f87979',
              borderColor: [], //'#f87979',
              pointStyle: 'rectRot',
              radius:[],
              data: [],
            },
            {
              label: "",
              backgroundColor: [], //'#79f879',
              borderColor: [], //'#79f879',
              pointStyle: 'rectRot', //'rectRot',
              radius:[],
              data: [],
            },
            {
              label: "",
              backgroundColor: [], //'#79f8f8',
              borderColor: [], //'#79f8f8',
              pointStyle: 'rectRot', //'rectRot',
              radius:[],
              data: [],
            },
          ],
        },
      };
    },
    computed: {
      maxVal() {      
        switch(this.scale) {
          case "xs":
            return 500;
          case "m":
            return 5000;
          case "l":
            return 20000;
          case "s" : 
          default:
            return 1000;
        }
      },
      /**
       * Rends les options dynamiques
       */
      chartOptions(){
        return{
          events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove','contextmenu','drag','dblclick'],
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
              datalabels: {
                  color: 'white',
                  display: false,
              },
              dragData: {
                round: 2,
                showTooltip: true,  
                onDragStart: function(e, datasetIndex, index, value) {
                },
                onDrag: (e, datasetIndex, index, value)=> {   
                  e.target.style.cursor = 'grabbing'
                },
                onDragEnd: (e, datasetIndex, index, value)=> {
                  e.target.style.cursor = 'default';
                       
                 var xIsExistIndex = -1;
                  var j = 0;
                  var pas = this.maxVal / 100;
                  this.originalematrice[datasetIndex][1].forEach(function(elem){
                    if(index*pas==elem){
                      xIsExistIndex =j;
                    }
                    j++;
                  });
                  if(xIsExistIndex>-1){
                    this.originalematrice[datasetIndex][0][xIsExistIndex]=value;
                  }else{
                    var j = 0;
                    while(index*pas>this.originalematrice[datasetIndex][1][j]){
                      j++;
                    }
                    this.originalematrice[datasetIndex][1].splice(j,0,""+index*pas);
                    this.originalematrice[datasetIndex][0].splice(j,0,value);
                    this.chartData.datasets[datasetIndex].backgroundColor[index]= colorPoint[datasetIndex];                 
                    this.chartData.datasets[datasetIndex].radius[index]=10;                  
                  }
                  this.calculateAllDatasets();
                  this.save();
                },
              },
              legend: {
                labels: {
                  color: 'white'
                },
              },
          },
          onHover: function(e) {
            const point = e.chart.getElementsAtEventForMode(e, 'nearest', { intersect: true }, false);
            if (point.length){
              e.native.target.style.cursor = 'grab';
            }
            else {
              e.native.target.style.cursor = 'default';
            }
          },
          onClick: this.handleRightClick,
          scales: {
            x: {
              ticks: {
                // For a category axis, the val is the index so the lookup via getLabelForValue is needed
                callback: function(val, index) {
                // Hide the label of every 10th dataset        
                  return index % 5 === 0 ? this.getLabelForValue(val) : '';
                },
                color: 'white',    
              },
              grid: {
                color: 'white',
                display: true,
                title: {
                  display: true,
                  text: 'Power (kWc)',
                  color: 'white',
                  font: {
                    size: 20,
                    weight: 'bold',
                    lineHeight: 1.2,
                  },
                  padding: {
                    top: 10,
                    left: 0,
                    right: 0,
                    bottom: 0
                  },
                },
              },               
              min:0,
              max:25000,
            },       
            y: {
              ticks: {
                color: 'white',
              },
              grid: { 
                color: 'white'
              },
              display: true,
              title: {
                display: true,
                text: 'Capital Cost (€/Wc)',
                color: 'white',
                font: {
                  size: 20,
                  weight: 'bold',
                  lineHeight: 1.2,
                },
                padding: {
                  top: 10,
                  left: 0,
                  right: 0,
                  bottom: 0
                },
              },               
              min:0,
            },
          },
        }
      }
    },
    mounted : function() { 

      this.Mode=this.mode;
      this.initCharts();
      this.$el.parentElement.firstChild.style="margin: auto";      
    },
    methods: {
    /**
     * Utilisé lors du changement de la selection Capex/Opex
     * "affecte" la valeur actuelle de la matrice (originalmatrice) dans la matrice correspondante et récupère la valeurs de l'autre en fonction du mode
     */
      swapMatrice(){
        if(this.Mode==="Capex"){
          this.originalematriceOpex=this.originalematrice;
          this.originalematrice=this.originalematriceCapex;
        }else if (this.Mode==="Opex"){
          this.originalematriceCapex=this.originalematrice;
          this.originalematrice=this.originalematriceOpex;
        }
      },
      /**
       * Modifie le x max et le y max du chart en fonction du mode
       */
      updateScales(){
        var yMax = 0;
        if (this.Mode==="Capex"){

          while (yMax-0.3<this.valeurPointMax) {
            yMax+=0.3;
          }
          this.chartOptions.scales.y.max=yMax;
          this.chartOptions.scales.y.title.text="Capital Cost (€/Wc)";
        }else if(this.Mode==="Opex"){

          while (yMax-0.02<this.valeurPointMax) {
            yMax+=0.02;
          }
          this.chartOptions.scales.y.max=yMax;
          this.chartOptions.scales.y.title.text="Operational Cost (€/Wc)";
        }
        //réinitialisation de la valeur du point max pour la cas ou le max diminue
        this.valeurPointMax=0;        
      },
      /**
       * Initialise les deux charts(Capex et Opex) et associe leurs datas à leurs <input> respectif dans la vue parente
       */
      initCharts(){
        var data=[];
        var i = 0;
        data.push(this.opex);
        data.push(this.capex);

        data.forEach(element => {
          i++;
          //on valorise data en fonction du mode choisi(Capex/Opex)
          var dataTemp = element;
          var dataLabels=Object.keys(dataTemp);
          // Extraction des labels
          this.chartData.datasets[0].label=dataLabels[0];
          this.chartData.datasets[1].label=dataLabels[1];
          this.chartData.datasets[2].label=dataLabels[2];
          this.chartData.datasets[3].label=dataLabels[3];
          
          var nbrPoints = 1.2 * this.maxVal;
          var pas = Math.round(this.maxVal / 100);
          const range = (start, stop, step = 1) =>
                Array(Math.ceil((stop - start) / step)).fill(start).map((x, y) => x + y * step);
          this.chartData.labels=range(0,nbrPoints,pas);
          
          // valorisation des données      
          var matrice = [];
          var index = 0;
          this.chartData.datasets.forEach(function(e) {
              index = dataLabels.indexOf(e.label);
              var dataSpe = dataTemp[dataLabels[index]];
              var dataSpeKeys = Object.keys(dataSpe);
              var thresholds = [];
              var costs = [];
              // Si pas de point "Zero", on en force un avec la valeur du premier cran
              if(dataSpeKeys[0] != '0' && dataSpeKeys[0]!=0) {
                thresholds.push('0');
              }
              dataSpeKeys.forEach(function(elem) {
                  if(!elem.startsWith('Sup')) {
                    thresholds.push(elem);
                  }
                  costs.push(dataSpe[elem]);
              });
              matrice.push([costs,thresholds,nbrPoints]);
          });
          this.originalematrice=matrice;
          if(i===1){
            this.originalematriceOpex=this.originalematrice;
            document.getElementById('inputOpex').value=JSON.stringify(this.originalematriceOpex);
          }else if(i===2){
            this.originalematriceCapex=this.originalematrice;
            document.getElementById('inputCapex').value=JSON.stringify(this.originalematriceCapex);
          }
          this.calculateAllDatasets();
        });
      },
      updateChart(){        
        this.save();
        this.swapMatrice();
        this.calculateAllDatasets();
      },
      calculateAllDatasets() {
        for(let i = 0; i<this.chartData.datasets.length; i++) {
          this.calculateDataset(i);
        }
        //actualisation après le chaque nouveau calcul de datasets
        this.updateScales();
      },
      calculateDataset(datasetIndex) {          
        var thresholds = this.originalematrice[datasetIndex][1];
        var costs = this.originalematrice[datasetIndex][0];
        var nbrPoints = 1.2*this.maxVal;
        this.originalematrice[datasetIndex][2]=nbrPoints;
        var pas = Math.round(this.maxVal / 100);
        var backgroundColors = [];
        var borderColors = [];
        var radiuses = [];
        var currentThreshold = 0;
        var data = [];
        for(var i=0; i<nbrPoints;i = i+pas) {
          if(i >= thresholds[currentThreshold+1] && currentThreshold < thresholds.length-1) {
            currentThreshold++;  
          }
          if(i%pas == 0) {
            if(currentThreshold==thresholds.length-1){
                data.push(costs[currentThreshold]);
            }else{
              var m = (costs[currentThreshold+1]-costs[currentThreshold])/(thresholds[currentThreshold+1]-thresholds[currentThreshold]);
              var b = costs[currentThreshold] - m*thresholds[currentThreshold];
              //definit la point maximum pour adapter le yMax du chart
              var value=(b+i*m);
              if(this.valeurPointMax<value){
                this.valeurPointMax=value;
              }
              data.push(value);
            }  
          }
          //si le point en cours à été ajouté manuellement/est l'un des points ref par défault (0/500/1000)
          if(thresholds.includes(""+i)){
            backgroundColors.push(colorPoint[datasetIndex]);
            borderColors.push(colorPoint[datasetIndex]);
            radiuses.push(10);                
          }else{
            backgroundColors.push("White");
            borderColors.push(colorPoint[datasetIndex]);
            radiuses.push(5);
          }             
        }          
        //update les labels(x) par rapport aux nombres de points et au pas (définit par this.scale)
        const range = (start, stop, step = 1) =>
              Array(Math.ceil((stop - start) / step)).fill(start).map((x, y) => x + y * step);
        this.chartData.labels=range(0,nbrPoints,pas);

        this.chartData.datasets[datasetIndex].data = data;
        this.chartData.datasets[datasetIndex].backgroundColor = backgroundColors;
        this.chartData.datasets[datasetIndex].borderColor = borderColors;
        this.chartData.datasets[datasetIndex].radius = radiuses;
      },
      /**
       * Si click droit :(type = contextmenu) supprime le point 
       * Si doubleclick : affiche la modale pour ajouter un point
       */
      handleRightClick(e) {
        if(e.type == 'contextmenu') {
          e.native.preventDefault();
          var point = e.chart.getElementsAtEventForMode(e, 'nearest', { intersect: true }, false);
          this.removePoint(point);
        } else if(e.type == 'click') {
          if(this.dblclickbool) {
            // THIS IS A DBL CLICK
            e.native.preventDefault();
            var point = e.chart.getElementsAtEventForMode(e, 'nearest', { intersect: true }, false);
            if(point.length) {
              let myModal = $("#modalpoint")[0];
              var rect = e.native.target.getBoundingClientRect();
              let val = this.chartData.datasets[point[0].datasetIndex].data[point[0].index];  
              document.getElementById("modalNumberInput").value=(parseFloat(val)).toFixed(4);//4 chiffres après la virgule                   
              let posY = e.native.clientY - rect.y;
              myModal.style.display="flex";
              myModal.style.left = e.native.clientX + "px"; // set the modal position to the last stored position
              myModal.style.top = posY + "px";
              this.newPointValue=val;
              this.tempPoint = point;

              //remplace la touche 'Enter' pour eviter les bugs avec la modal: par le click sur le button de la modal lorsque celle-ci est affichée
              $('#formPost').on('keyup keypress', function(e) {
                var diplayModal=document.getElementById('modalpoint').style.display;
                var keyCode = e.keyCode || e.which;
                if (keyCode === 13 && diplayModal==="flex") { 
                  e.preventDefault();
                  return document.getElementById("btnModal").click();
                }
              });
            }
          } else {
            // THIS IS A FIRST CLICK
            this.dblclickbool= true;
            setTimeout(() => {
              this.dblclickbool = false;
            }, 500);
          }
        }
      },
      removePoint(point) {
        if(point.length) { // to filter out right click in empty space
          var datasetIndex = point[0].datasetIndex;
          var pointIndex = point[0].index;
          var pas = this.maxVal / 100;
          var indexASuppr = this.originalematrice[datasetIndex][1].indexOf(""+pointIndex*pas);
          this.originalematrice[datasetIndex][1].splice(indexASuppr,1);
          this.originalematrice[datasetIndex][0].splice(indexASuppr,1);
          //Mise à jour des données du charts/scales
          this.calculateAllDatasets();
          this.save();
        }
      },
      addPoint(point,value) {        
        if(point.length) { // to filter out right click in empty space
          var datasetIndex = point[0].datasetIndex;
          var pointIndex = point[0].index;
          var pas = this.maxVal / 100;
          var newThreshold = pointIndex * pas;
          var indexACreer = 0;
          var thresholds = this.originalematrice[datasetIndex][1];
          while(thresholds[indexACreer] < newThreshold && indexACreer < thresholds.length) {
            indexACreer++;
          }
          if(thresholds[indexACreer] == newThreshold) {
            this.originalematrice[datasetIndex][1].splice(indexACreer,1,newThreshold+"");
            this.originalematrice[datasetIndex][0].splice(indexACreer,1,value);
          } else {
            this.originalematrice[datasetIndex][1].splice(indexACreer,0,newThreshold+"");
            this.originalematrice[datasetIndex][0].splice(indexACreer,0,parseFloat(value));
          }
          //Mise à jour des données du charts/scales
          this.calculateAllDatasets();
          this.save();
        }
      },
      validateInput() {
        let value = $("#modalNumberInput")[0].value;
        this.addPoint(this.tempPoint,value);
        let myModal = $("#modalpoint")[0];
        myModal.style.display="none";
        this.tempPoint=[]; 
      },
      /**
       * Associations des données des matrices respectives à leurs <inputs> dans la vue parente
       */
      save(){
        document.getElementById('inputOpex').value=JSON.stringify(this.originalematriceOpex);
        document.getElementById('inputCapex').value=JSON.stringify(this.originalematriceCapex);
      }
    },
    watch: {
      scale() {
        this.save();
        this.calculateAllDatasets();
      },
      mode(){
        this.Mode=this.mode;
        this.updateChart();
      }
    }
  }
</script>
    